import { HaNContext, type HaNPersonRow, type HaNSelection, HaNViewStoreContext } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";

import { useFitNodeInView } from "../map/useFitNodeInView";
import { useChangeFloor } from "../shared/useChangeFloor";

/**
 * Selects a person and opens their details. That selects their desk or area on the map and zooms to it, also when
 * it's already in view. A person on another floor takes the page there, and that floor's map opens on them.
 */
export const useSelectPerson = () => {
  const { floor } = useRequiredContext(HaNContext);
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const changeFloor = useChangeFloor();
  const fitNodeInView = useFitNodeInView();

  return ({ owner, reservation }: HaNPersonRow) => {
    const { floorId, nodeId } = reservation.workspace;
    const selection: HaNSelection = { kind: "person", id: owner.id, nodeId };

    const select = () => {
      viewStore.select("people", selection, { openDetails: true });
    };

    if (floorId && floorId !== floor.floorId) {
      changeFloor(floorId, select);

      return;
    }

    select();
    fitNodeInView(nodeId, { evenIfInView: true });
  };
};
